@let data = note();
<onyx-information-heading>
  {{ heading() | translate }}

  <ng-container actions>
    @if (route()) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        [icon]="data?.content ? 'edit-outlined' : 'add-outlined'"
        [circle]="true"
        [onyxTooltip]="data?.content ? 'labels.edit' : 'labels.add'"
        (click)="edit()"
      ></onyx-icon-button>
    }
  </ng-container>
</onyx-information-heading>

@if (data && data.content) {
  <div class="note">
    <div class="details f-body-s">
      <span>{{ 'labels.lastUpdatedAt' | translate }}</span>

      <span>·</span>

      <span>{{ data.updatedAt | onyxDate: 'date-time' }}</span>
    </div>

    <p class="content f-paragraph-s">{{ data.content }}</p>
  </div>
} @else {
  <div class="note empty">
    <p class="f-muted">{{ 'labels.missingNote' | translate }}</p>
  </div>
}
